import React from "react";
import { Row, Col, Input } from "antd";
import moment from "moment";
import Date from "../Date/Date";
import Radio from "../Radio/Radio";
import TextBox from "../TextBox/TextBox";
import Int from "../Int/Int";
import Decimal from "../Decimal/Decimal";
import Range from "../Range/Range";
import TypSubType from "../TypSubType/TypSubType";
import UniDropAdv from "../UniDrop/UniDropAdv";

const UnifiedInput = ({
  form,
  name,
  pname,
  label,
  defaultValue,
  typ,
  disabled,
  source,
  sourceParams,
  labelSpan,
  key,
  format,
  errorMessage,
  required,
  placeHolder,
  options,
  defaultFrom,
  defaultTo,
  data,
  isIST,
  url,
  colSpan,
  includeAll,
  extraData,
  multiSelect,
  modalData,
  modalKey,
  searchable,
  auxOnChange,
  minHeight,
  onChange,
  isCache,
  cacheId,
  labelCol,
  labelAsVal
}) => {
  // console.log(defaultValue);
  // if (typ === "datePicker" || typ === "dateTimePicker") {
  //   dateSets[name] = format;
  // }
  let DefaultFrom = moment().format(format);
  let DefaultTo = moment().format(format);

  if (typ === "rangePicker") {
    if (data && data["defaultFrom"]) {
      DefaultFrom = moment().add(data["defaultFrom"], "days").format(format);
    }
    if (data && data["defaultTo"]) {
      DefaultTo = moment().add(data["defaultFrom"], "days").format(format);
    }
  }

  const { TextArea } = Input;

  //   console.log("MODAL DATA", modalData, modalKey);

  if (modalData && modalKey) {
    defaultValue = modalData[modalKey];
  }

  return (
    <>
      {typ === "datePicker" ? (
        <>

          <Col span={colSpan ? colSpan : 12}>
            <Date
              labelCol={labelCol}
              name={name}
              form={form}
              label={label}
              format={format}
              required={required}
              disabled={disabled}
              defaultValue={
                modalData && modalKey
                  ? moment(modalData[modalKey]).format(format)
                  : defaultValue?.toString()
                    ? moment().add(defaultValue, 'days').format(format)
                    : ""
              }
              // defaultValue={
              //   modalData && modalKey

              //     ? moment(modalData[modalKey]).format(format)
              //     : defaultValue

              //     ? modalData[modalKey] == undefined
              //     : moment().format(format)


              //     // ? modalData[modalKey] == undefined
              //     // : defaultValue = 0

              //     ? moment().add(defaultValue, "days").format(format)
              //     : moment().format(format)
              // }



              errorMessage={
                errorMessage ? errorMessage : "Please Select " + label
              }
              placeholder={placeHolder || "Select " + label}
              isIST={isIST ? isIST : false}





            />
          </Col>
        </>
      ) : (
        <></>
      )}
      {typ === "rangePicker" ? (
        <Col span={colSpan ? colSpan : 12}>
          <Range
            placeholder={placeHolder ? placeHolder : "Select " + label}
            errorMessage={
              errorMessage ? errorMessage : "Please Select " + label
            }
            disabled={disabled ? disabled : false}
            required={required}
            name={name}
            format={format}
            label={label}
            isIST={isIST ? isIST : false}
            defaultValue={
              modalData && modalKey
                ? [
                  moment(defaultFrom).format(format),
                  moment(defaultTo).format(format),
                ]
                : defaultFrom || defaultTo
                  ? [
                    defaultFrom
                      ? moment().add(defaultFrom, "days").format(format)
                      : moment().format(format),
                    defaultTo
                      ? moment().add(defaultTo, "days").format(format)
                      : moment().format(format),
                  ]
                  : null
            }
          />
        </Col>
      ) : (
        <></>
      )}
      {typ === "dateTimePicker" ? (
        <Col span={colSpan ? colSpan : 12}>
          <Date
            name={name}
            label={label}
            form={form}
            required={required}
            isIST={isIST ? isIST : false}
            disabled={disabled}
            showTime={true}
            defaultValue={
              modalData && modalKey
                ? moment(modalData[modalKey]).format(format)
                : defaultValue
                  ? moment().add(defaultValue, "days").format(format)
                  : moment().format(format)
            }
            errorMessage={
              errorMessage ? errorMessage : "Please Select " + label
            }
            placeholder={"Select " + label}
            format={format ? format : "YYYY-MM-DD HH:mm:ss"}
          />
        </Col>
      ) : (
        <></>
      )}
      {typ === "TypSubTyp" ? (
        <>
          {/* <Row gutter={24} justify="center"> */}
          <Col span={colSpan ? colSpan : 12}>
            <TypSubType
              form={form}
              url={"/" + source}
              urlData={sourceParams}
              typName={sourceParams["typName"]}
              typLabel={sourceParams["typName"]}
              typErrorMessage={
                "Please Enter " + sourceParams["typLabel"]
                  ? sourceParams["typLabel"]
                  : "Type"
              }
              typRequired={required}
              typPlaceholder={`Select ${sourceParams["typLabel"] ? sourceParams["typLabel"] : "Type"
                }`}
              subTypName={sourceParams["subTypName"]}
              subTypLabel={sourceParams["subTypName"]}
              subTypeErrorMessage={
                "Please Enter __" + sourceParams["subTypLabel"]
                  ? sourceParams["subTypLabel"]
                  : "SubType"
              }
              subTypeRequired={required}
              subTypPlaceholder={`Select ${sourceParams["subTypLabel"]
                  ? sourceParams["subTypLabel"]
                  : "SubType"
                }`}
              disabled={disabled}
            />
          </Col>
          {/* </Row> */}
        </>
      ) : (
        <></>
      )}
      {typ === "radio" ? (
        <Col span={colSpan ? colSpan : 12}>
          <Radio
            form={form}
            name={name}
            // labelColSpan={16}
            label={label}
            disabled={disabled}
            required={required}
            defaultValue={defaultValue ? defaultValue : true}
            options={[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ]}
            errorMessage={
              errorMessage ? errorMessage : "Please Select " + label
            }
          />
        </Col>
      ) : (
        <></>
      )}
      {typ === "textBox" ? (
        // <Row gutter={24} justify="center" key={key}>
        <Col span={colSpan ? colSpan : 12}>
          <TextBox
            form={form}
            type="input"
            name={name}
            label={label}
            disabled={disabled}
            required={required}
            errorMessage={errorMessage ? errorMessage : "Please Enter " + label}
            defaultValue={defaultValue ? defaultValue : null}
          //   maxChar={400}
          //   maxCharErrorMessage="Accepted only 400 Chars"
          />
        </Col>
      ) : (
        // </Row>
        <></>
      )}

      {typ === "textArea" ? (
        <>
          {/* {console.log("Area")} */}
          {/* <Row gutter={24} justify="center" key={key}> */}
          <Col span={colSpan ? colSpan : 12} style={{ marginBottom: "10px" }}>
            <TextArea
              value={defaultValue ? defaultValue : ""}
              rows={2}
              disabled={disabled ? disabled : false}
              placeholder={placeHolder ? placeHolder : ""}
              style={{
                minHeight: minHeight ? minHeight : "",
                color: disabled ? "rgba(0, 0, 0, 0.25)" : "",
              }}
            />
          </Col>
          {/* </Row> */}
        </>
      ) : (
        <></>
      )}

      {typ === "intControl" ? (
        // <Row gutter={24} justify="center" key={key}>
        <Col span={colSpan ? colSpan : 12}>
          <Int
            form={form}
            name={name}
            label={label}
            disabled={disabled}
            required={required}
            errorMessage={errorMessage ? errorMessage : "Please Enter " + label}
            defaultValue={defaultValue ? defaultValue : 0}
          />
        </Col>
      ) : (
        // </Row>
        <></>
      )}

      {typ === "decimalControl" ? (
        // <Row gutter={24} justify="center" key={key}>
        <Col span={colSpan ? colSpan : 12}>
          <Decimal
            form={form}
            name={name}
            label={label}
            disabled={disabled}
            defaultValue={defaultValue ? defaultValue : 0}
            errorMessage={errorMessage ? errorMessage : "Please Enter " + label}
            required={required}
          />
        </Col>
      ) : (
        // </Row>
        <></>
      )}

      {typ === "dropDown" ? (
        // <Row gutter={24} justify="center" key={key}>
        <>
          {source === "mdict" ||
            source === "cropdown" ||
            source === "data" ||
            source === "dynamic" ? (
            <Col span={colSpan ? colSpan : 12}>
              <UniDropAdv
                labelAsVal={labelAsVal}
                isCache={isCache}
                cacheId={cacheId}
                form={form}
                // labelSpan={labelSpan ? labelSpan : 12}
                colSpan={colSpan ? colSpan : 12}
                multiSelect={multiSelect}
                url={url}
                disabled={disabled}
                source={source}
                options={options}
                extraData={extraData}
                urlData={sourceParams ? sourceParams : {}}
                pname={pname ? pname : name}
                name={name}
                label={label}
                errorMessage={"Please Select " + label}
                required={required}
                placeholder={"Select " + label}
                defaultValue={defaultValue ? defaultValue : null}
                includeAll={includeAll ? includeAll : false}
                searchable={searchable ? searchable : false}
                onChange={auxOnChange}
              />
            </Col>
          ) : (
            <></>
          )}
        </>
      ) : (
        // </Row>
        <></>
      )}
    </>
  );
};
export default UnifiedInput;
